/* __next_internal_client_entry_do_not_use__ MaybeBrandLocationAndReviews auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MaybeBrandReviewTile } from "@faire/retailer-visitor-shared/components/MaybeBrandReviewTile/MaybeBrandReviewTile";
import { localNum } from "@faire/web--source/common/localization";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { CountryFlag } from "@faire/web--source/ui/CountryFlag";
import React from "react";
export var MaybeBrandLocationAndReviews = function(param) {
    var isLoggedInRetailer = param.isLoggedInRetailer, avgBrandReviewRating = param.avgBrandReviewRating, brandReviewCount = param.brandReviewCount, flagCountryCode = param.flagCountryCode, shipsFromMessage = param.shipsFromMessage;
    if (isLoggedInRetailer) {
        return null;
    }
    var flagIcon = CountryFlag({
        country: flagCountryCode,
        size: "16px"
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MaybeBrandReviewTile, {
                rating: ratingString(avgBrandReviewRating, brandReviewCount)
            }),
            flagIcon ? /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    flagIcon,
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: 6
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        children: shipsFromMessage
                    })
                ]
            }) : null
        ]
    });
};
var ratingString = function(avgBrandReviewRating, brandReviewCount) {
    if (avgBrandReviewRating && brandReviewCount) {
        return "".concat(avgBrandReviewRating, " (").concat(localNum(brandReviewCount), ")");
    }
    return undefined;
};
